module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.title) ? _c('h1', {
    staticClass: "MediaGridItemTitle",
    class: _vm.titleClasses,
    domProps: {
      "innerHTML": _vm._s(_vm.data.title)
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70e7b75a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MediaGridItemTitle.vue
// module id = 779
// module chunks = 1474